import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import isPortalSpecificObjectType from 'customer-data-objects/crmObject/isPortalSpecificObjectType';
import { useSelectedObjectTypeId } from '../../../objectTypeIdContext/hooks/useSelectedObjectTypeId';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const portalId = PortalIdParser.get();
export const PipelineEmptyPage = () => {
  const objectTypeId = useSelectedObjectTypeId();
  const isCobject = isPortalSpecificObjectType(objectTypeId);
  const settingsUrl = `/pipelines-settings/${portalId}/object/${objectTypeId}`;
  return /*#__PURE__*/_jsx(EmptyState, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "indexPage.emptyBoardPage.titleAll"
    }),
    primaryContent: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "400",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "indexPage.emptyBoardPage.bodyAll"
      }), isCobject && /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(KnowledgeBaseButton, {
          url: "https://knowledge.hubspot.com/crm-setup/use-custom-objects",
          useZorse: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "indexPage.emptyBoardPage.kbLink"
          })
        })
      }), /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(Button, {
          href: settingsUrl,
          external: true,
          use: "tertiary",
          marginBlockStart: "300",
          marginBlockEnd: "300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "indexPage.emptyBoardPage.button"
          })
        })
      })]
    }),
    secondaryContent: /*#__PURE__*/_jsx(Illustration, {
      name: "custom-objects",
      width: 200
    }),
    secondaryContentWidth: 200
  });
};